import { variantPrefix } from '../../../constants'

export { default as FIELDS_REPORT_A } from './fields/reporta.json'
export { default as FIELDS_REPORT_B } from './fields/reportb.json'
export { default as FIELDS_REPORT_C } from './fields/reportc.json'
export { default as FIELDS_VOTING } from './fields/voting.json'

export const variant = variantPrefix
